import React, { useContext, useEffect } from "react";
import { useForm, useFormState } from "react-hook-form";
import { useParams } from "react-router-dom";

import { AppContext } from "../../../core/context/appContextProvider";
import useRole from "../../../core/routing/useRole";
import { updateFeatureConfig } from "../../../services/client.service.v2";
import { useClientEffect } from "../../../services/hooks/useClientsEffect/useClientEffect.hooks";
import { FeatureConfig } from "../../../utils/types/client.type";
import { ScopeRole } from "../../../utils/types/user.type";

interface RouteProp {
  id: string;
  arkTag: string;
  section: string;
}

const defaultValues = {
  glLocked: false,
  allocationLocked: false,
  soiLocked: false,
};

export const useFeature = () => {
  const { id } = useParams<RouteProp>();
  const [loading, setLoading] = React.useState(false);
  const {
    client,
    fetchClient,
    loading: loadingClient,
  } = useClientEffect(id !== "new" ? id : undefined);
  const { informationAlert, refetchSideNav } = useContext(AppContext);
  const { handleSubmit, control, reset } = useForm<FeatureConfig>({
    defaultValues,
  });

  const { isDirty } = useFormState({
    control,
  });

  useEffect(() => {
    if (client?.id) {
      reset({
        id: client.id,
        glLocked: client?.glLocked === false ? false : true || true,
        allocationLocked:
          client?.allocationLocked === false ? false : true || true,
        soiLocked: client?.soiLocked === false ? false : true || true,
      });
    }
  }, [client]);

  const onSubmit = async (data: FeatureConfig) => {
    setLoading(true);
    try {
      await updateFeatureConfig(data);
      await Promise.all([fetchClient(), refetchSideNav()]);
    } catch (error) {
      informationAlert("Error in updating feature config", "error");
    } finally {
      setLoading(false);
    }
  };

  const onCancel = () => {
    fetchClient();
  };

  return {
    handleSubmit,
    isDirty,
    control,
    onSubmit,
    onCancel,
    loading: loadingClient || loading,
  };
};
